/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!function(a,b,c){var d=window.matchMedia;"undefined"!=typeof module&&module.exports?module.exports=c(d):"function"==typeof define&&define.amd?define(function(){return b[a]=c(d)}):b[a]=c(d)}("enquire",this,function(a){"use strict";function b(a,b){var c,d=0,e=a.length;for(d;e>d&&(c=b(a[d],d),c!==!1);d++);}function c(a){return"[object Array]"===Object.prototype.toString.apply(a)}function d(a){return"function"==typeof a}function e(a){this.options=a,!a.deferSetup&&this.setup()}function f(b,c){this.query=b,this.isUnconditional=c,this.handlers=[],this.mql=a(b);var d=this;this.listener=function(a){d.mql=a,d.assess()},this.mql.addListener(this.listener)}function g(){if(!a)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!a("only all").matches}return e.prototype={setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},f.prototype={addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var c=this.handlers;b(c,function(b,d){return b.equals(a)?(b.destroy(),!c.splice(d,1)):void 0})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){b(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";b(this.handlers,function(b){b[a]()})}},g.prototype={register:function(a,e,g){var h=this.queries,i=g&&this.browserIsIncapable;return h[a]||(h[a]=new f(a,i)),d(e)&&(e={match:e}),c(e)||(e=[e]),b(e,function(b){d(b)&&(b={match:b}),h[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},new g});

/* Equal heights (vanilla) - based on Simple jQuery Equal Heights v1.5.1 */
function equalHeights(elements) {
  var maxHeight = 0;
  var i;
  for (i = 0; i < elements.length; i++) {
    elements[i].style.height = 'auto';
    var height = elements[i].offsetHeight;
    if (height > maxHeight) maxHeight = height;
  }
  for (i = 0; i < elements.length; i++) {
    elements[i].style.height = maxHeight + 'px';
  }
}
document.querySelectorAll('[data-equal]').forEach(function(container) {
  var selector = container.getAttribute('data-equal');
  if (selector) {
    equalHeights(Array.prototype.slice.call(container.querySelectorAll(selector)));
  }
});

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

/* =============================================================================
   DOM utilities & jQuery bridge (flexslider, zoom, imagesLoaded plugin only)
============================================================================= */
window.timber = window.timber || {};
window.theme = window.theme || {};

timber.$ = function(el) {
  return window.jQuery(el);
};

theme.dom = {
  qs: function(selector, context) {
    return (context || document).querySelector(selector);
  },
  qsa: function(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  },
  byId: function(id) {
    return document.getElementById(id);
  },
  on: function(el, event, handler) {
    if (!el) return;
    if (el.length !== undefined && !el.nodeType) {
      for (var i = 0; i < el.length; i++) el[i].addEventListener(event, handler);
      return;
    }
    el.addEventListener(event, handler);
  },
  off: function(el, event, handler) {
    if (!el) return;
    if (el.length !== undefined && !el.nodeType) {
      for (var i = 0; i < el.length; i++) el[i].removeEventListener(event, handler);
      return;
    }
    el.removeEventListener(event, handler);
  },
  delegate: function(parent, event, selector, handler) {
    theme.dom.on(parent, event, function(evt) {
      var target = evt.target.closest(selector);
      if (target && parent.contains(target)) handler.call(target, evt);
    });
  },
  addClass: function(el, className) {
    if (!el || !className) return;
    if (el.classList) el.classList.add(className);
  },
  removeClass: function(el, className) {
    if (!el || !className) return;
    if (el.classList) el.classList.remove(className);
  },
  toggleClass: function(el, className) {
    if (!el || !className) return;
    if (el.classList) el.classList.toggle(className);
  },
  hasClass: function(el, className) {
    return el && el.classList && el.classList.contains(className);
  },
  html: function(el, content) {
    if (!el) return '';
    if (content === undefined) return el.innerHTML;
    el.innerHTML = content;
  },
  text: function(el, content) {
    if (!el) return '';
    if (content === undefined) return el.textContent;
    el.textContent = content;
  },
  val: function(el, value) {
    if (!el) return '';
    if (value === undefined) return el.value;
    el.value = value;
  },
  attr: function(el, name, value) {
    if (!el) return null;
    if (value === undefined) return el.getAttribute(name);
    el.setAttribute(name, value);
  },
  prop: function(el, name, value) {
    if (!el) return null;
    if (value === undefined) return el[name];
    el[name] = value;
  },
  show: function(el) {
    if (el) el.style.display = '';
  },
  hide: function(el) {
    if (el) el.style.display = 'none';
  },
  css: function(el, props) {
    if (!el || !props) return;
    var key;
    for (key in props) {
      if (Object.prototype.hasOwnProperty.call(props, key)) el.style[key] = props[key];
    }
  },
  outerHeight: function(el) {
    if (!el) return 0;
    var style = window.getComputedStyle(el);
    return el.offsetHeight + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
  },
  outerWidth: function(el, includeMargin) {
    if (!el) return 0;
    var width = el.offsetWidth;
    if (includeMargin) {
      var style = window.getComputedStyle(el);
      width += parseFloat(style.marginLeft) + parseFloat(style.marginRight);
    }
    return width;
  },
  offset: function(el) {
    if (!el) return null;
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top + window.pageYOffset,
      left: rect.left + window.pageXOffset
    };
  },
  scrollTop: function(el, value) {
    if (el === window || el === document || el === document.documentElement) {
      if (value === undefined) return window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo(0, value);
      return;
    }
    if (value === undefined) return el.scrollTop;
    el.scrollTop = value;
  },
  contains: function(parent, child) {
    return parent && child && parent !== child && parent.contains(child);
  },
  insertAfter: function(newNode, referenceNode) {
    if (!referenceNode || !referenceNode.parentNode) return;
    var parent = referenceNode.parentNode;
    var next = referenceNode.nextSibling;
    if (newNode.nodeType === 11) {
      while (newNode.firstChild) {
        parent.insertBefore(newNode.firstChild, next);
      }
    } else {
      parent.insertBefore(newNode, next);
    }
  },
  prepend: function(parent, node) {
    if (!parent) return;
    if (node.nodeType) {
      parent.insertBefore(node, parent.firstChild);
    } else {
      parent.insertAdjacentHTML('afterbegin', node);
    }
  },
  append: function(parent, node) {
    if (!parent) return;
    if (node.nodeType) {
      parent.appendChild(node);
    } else {
      parent.insertAdjacentHTML('beforeend', node);
    }
  },
  remove: function(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  },
  empty: function(el) {
    if (el) el.innerHTML = '';
  },
  wrap: function(el, wrapper) {
    if (!el || !el.parentNode) return;
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },
  closest: function(el, selector) {
    return el ? el.closest(selector) : null;
  },
  siblings: function(el, selector) {
    if (!el || !el.parentNode) return [];
    var siblings = Array.prototype.slice.call(el.parentNode.children);
    return siblings.filter(function(node) {
      return node !== el && (!selector || node.matches(selector));
    });
  },
  slideToggle: function(el, duration) {
    duration = duration || 200;
    if (!el) return;
    if (window.getComputedStyle(el).display !== 'none') {
      el.style.height = el.offsetHeight + 'px';
      el.offsetHeight;
      el.style.transition = 'height ' + duration + 'ms';
      el.style.overflow = 'hidden';
      el.style.height = '0';
      setTimeout(function() {
        el.style.display = 'none';
        el.style.height = '';
        el.style.transition = '';
        el.style.overflow = '';
      }, duration);
    } else {
      el.style.display = 'block';
      var height = el.scrollHeight;
      el.style.height = '0';
      el.style.overflow = 'hidden';
      el.offsetHeight;
      el.style.transition = 'height ' + duration + 'ms';
      el.style.height = height + 'px';
      setTimeout(function() {
        el.style.height = '';
        el.style.transition = '';
        el.style.overflow = '';
      }, duration);
    }
  },
  bindJsQtyAdjuster: function(el, qtyMin) {
    if (!el) return;
    var dom = theme.dom;
    dom.off(el, 'click', el._jsQtyAdjusterClick);
    el._jsQtyAdjusterClick = function() {
      var qtySelector = el.parentNode.querySelector('.js--num');
      if (!qtySelector) return;
      var qty = parseInt(dom.val(qtySelector), 10);
      if ((parseFloat(qty) != parseInt(qty, 10)) || isNaN(qty)) qty = 1;
      if (dom.hasClass(el, 'js--add')) qty += 1;
      else qty = qty <= qtyMin ? qtyMin : qty - 1;
      dom.val(qtySelector, qty);
    };
    dom.on(el, 'click', el._jsQtyAdjusterClick);
  },
  animateScrollTop: function(duration) {
    var start = window.pageYOffset || document.documentElement.scrollTop;
    if (start <= 0) return;
    var startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var ease = 0.5 - Math.cos(progress * Math.PI) / 2;
      window.scrollTo(0, start * (1 - ease));
      if (progress < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  },
  serializeForm: function(form) {
    var params = new URLSearchParams(new FormData(form));
    return params.toString();
  },
  loadScript: function(src) {
    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  },
  param: function(obj) {
    var params = new URLSearchParams();
    var key;
    for (key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && obj[key] !== null) {
        params.set(key, obj[key]);
      }
    }
    return params.toString();
  }
};

theme.fillTemplateFields = function(root, data) {
  if (!root || !data) return;
  var fields = root.querySelectorAll ? root.querySelectorAll('[data-field]') : [];
  var i;
  for (i = 0; i < fields.length; i++) {
    var el = fields[i];
    var field = el.getAttribute('data-field');
    var value = data[field];
    if (value === undefined || value === null) continue;
    var attrName = el.getAttribute('data-attribute');
    if (attrName) {
      el.setAttribute(attrName, value);
    } else if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
      el.value = value;
    } else if (el.tagName === 'IMG') {
      el.src = value;
    } else {
      el.textContent = value;
    }
  }
  var classFields = root.querySelectorAll ? root.querySelectorAll('[data-class-field]') : [];
  for (i = 0; i < classFields.length; i++) {
    var classEl = classFields[i];
    var classField = classEl.getAttribute('data-class-field');
    if (data[classField]) classEl.classList.add(data[classField]);
  }
  var lineFields = root.querySelectorAll ? root.querySelectorAll('[data-line-field]') : [];
  for (i = 0; i < lineFields.length; i++) {
    var lineEl = lineFields[i];
    var lineField = lineEl.getAttribute('data-line-field');
    if (data[lineField] !== undefined) lineEl.setAttribute('data-line', data[lineField]);
  }
  var qtyFields = root.querySelectorAll ? root.querySelectorAll('[data-qty-field]') : [];
  for (i = 0; i < qtyFields.length; i++) {
    var qtyEl = qtyFields[i];
    var qtyField = qtyEl.getAttribute('data-qty-field');
    if (data[qtyField] !== undefined) qtyEl.setAttribute('data-qty', data[qtyField]);
  }
  var idFields = root.querySelectorAll ? root.querySelectorAll('[data-id-field]') : [];
  for (i = 0; i < idFields.length; i++) {
    var idEl = idFields[i];
    var idField = idEl.getAttribute('data-id-field');
    if (data[idField] !== undefined) idEl.setAttribute('data-id', data[idField]);
  }
  var nameFields = root.querySelectorAll ? root.querySelectorAll('[data-name-field]') : [];
  for (i = 0; i < nameFields.length; i++) {
    var nameEl = nameFields[i];
    var nameField = nameEl.getAttribute('data-name-field');
    if (data[nameField]) nameEl.setAttribute('name', data[nameField]);
  }
  var idNameFields = root.querySelectorAll ? root.querySelectorAll('[data-id-name-field]') : [];
  for (i = 0; i < idNameFields.length; i++) {
    var idNameEl = idNameFields[i];
    var idNameField = idNameEl.getAttribute('data-id-name-field');
    if (data[idNameField]) idNameEl.setAttribute('id', data[idNameField]);
  }
  var removeLinks = root.querySelectorAll ? root.querySelectorAll('.ajaxifyCart--remove') : [];
  for (i = 0; i < removeLinks.length; i++) {
    if (data.line !== undefined) {
      removeLinks[i].href = '/cart/change?line=' + data.line + '&quantity=0';
    }
  }
};

theme.renderTemplate = function(templateId, data) {
  var template = document.getElementById(templateId);
  if (!template) return document.createDocumentFragment();
  var clone = template.content.cloneNode(true);
  theme.fillTemplateFields(clone, data);
  return clone;
};

theme.renderCartTemplate = function(cart, btnClass) {
  var fragment = theme.renderTemplate('cartTemplate', {
    totalPrice: Shopify.formatMoney(cart.total_price, ajaxifyShopify.settings ? ajaxifyShopify.settings.moneyFormat : moneyFormat),
    btnClass: btnClass || ''
  });
  var itemsContainer = fragment.querySelector('[data-cart-items]');
  if (!itemsContainer) return fragment;
  cart.items.forEach(function(cartItem, index) {
    var itemAdd = cartItem.quantity + 1;
    var itemMinus = cartItem.quantity - 1;
    var itemQty = cartItem.quantity + ' x';
    var prodImg = cartItem.image.replace(/(\.[^.]*)$/, '_small$1').replace('http:', '');
    var prodName = cartItem.title.replace(/(\-[^-]*)$/, '');
    var prodVariation = cartItem.title.replace(/^[^\-]*/, '').replace(/-/, '');
    itemsContainer.appendChild(theme.renderTemplate('cartItemTemplate', {
      key: cartItem.key,
      line: index + 1,
      url: cartItem.url,
      img: prodImg,
      name: prodName,
      variation: prodVariation,
      itemAdd: itemAdd,
      itemMinus: itemMinus,
      itemQty: itemQty,
      price: Shopify.formatMoney(cartItem.price, ajaxifyShopify.settings ? ajaxifyShopify.settings.moneyFormat : moneyFormat)
    }));
  });
  return fragment;
};

//* Ajaxify.js.liquid *//

/*============================================================================
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  Plugin Documentation - https://shopify.github.io/Timber/#ajax-cart

  Ajaxify the add to cart experience and flip the button for inline confirmation,
  show the cart in a modal, or a 3D drawer.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajaxify plugin

  This requires:
    - jQuery (flexslider, zoom, imagesLoaded plugin bridge only)
    - Modernizr (vendor.js)
    - snippet/ajax-cart-template.liquid (HTML template elements)

  JQUERY API (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  Includes slight modifications to addItemFromForm.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return String(attribute).trim();
}

/*============================================================================
  API Functions
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ( !Shopify.formatMoney ) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

Shopify.onProduct = function(product) {
  // alert('Received everything we ever wanted to know about ' + product.title);
};

Shopify.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

Shopify.ajaxHeaders = function(extraHeaders) {
  return Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json'
  }, extraHeaders || {});
};

Shopify.updateCartNote = function(note, callback) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: Shopify.ajaxHeaders(),
    body: 'note=' + encodeURIComponent(attributeToString(note))
  })
    .then(function(response) {
      if (!response.ok) return response.json().then(function(data) { throw data; });
      return response.json();
    })
    .then(function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        Shopify.onCartUpdate(cart);
      }
    })
    .catch(function(data) {
      Shopify.onError({ responseText: JSON.stringify(data) }, 'error');
    });
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data;
  try {
    data = JSON.parse(XMLHttpRequest.responseText);
  } catch (e) {
    data = {};
  }
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  } else {
    alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item associated with the added item
==============================================================================*/
Shopify.addItem = function(variant_id, quantity, callback) {
  quantity = quantity || 1;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: Shopify.ajaxHeaders(),
    body: 'quantity=' + quantity + '&id=' + variant_id
  })
    .then(function(response) {
      if (!response.ok) return response.json().then(function(data) { throw data; });
      return response.json();
    })
    .then(function(line_item) {
      if (typeof callback === 'function') {
        callback(line_item);
      } else {
        Shopify.onItemAdded(line_item);
      }
    })
    .catch(function(data) {
      Shopify.onError({ responseText: JSON.stringify(data) }, 'error');
    });
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item
    - Allow use of form element instead of id
    - Allow custom error callback
==============================================================================*/
Shopify.addItemFromForm = function(form, callback, errorCallback) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: Shopify.ajaxHeaders(),
    body: theme.dom.serializeForm(form)
  })
    .then(function(response) {
      if (!response.ok) return response.json().then(function(data) { throw { data: data, response: response }; });
      return response.json();
    })
    .then(function(line_item) {
      if (typeof callback === 'function') {
        callback(line_item, form);
      } else {
        Shopify.onItemAdded(line_item, form);
      }
    })
    .catch(function(err) {
      var data = err.data || err;
      if (typeof errorCallback === 'function') {
        errorCallback({
          responseText: JSON.stringify(data),
          status: (err.response && err.response.status) || data.status
        }, 'error');
      } else {
        Shopify.onError({ responseText: JSON.stringify(data) }, 'error');
      }
    });
};

Shopify.getCart = function(callback) {
  fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        Shopify.onCartUpdate(cart);
      }
    });
};

Shopify.getProduct = function(handle, callback) {
  fetch('/products/' + handle + '.js')
    .then(function(response) { return response.json(); })
    .then(function(product) {
      if (typeof callback === 'function') {
        callback(product);
      } else {
        Shopify.onProduct(product);
      }
    });
};

Shopify.changeItem = function(line, quantity, callback) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: Shopify.ajaxHeaders(),
    body: 'quantity=' + quantity + '&line=' + line
  })
    .then(function(response) {
      if (!response.ok) return response.json().then(function(data) { throw data; });
      return response.json();
    })
    .then(function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        Shopify.onCartUpdate(cart);
      }
    })
    .catch(function(data) {
      Shopify.onError({ responseText: JSON.stringify(data) }, 'error');
    });
};

/*============================================================================
  Ajaxify Shopify Add To Cart
==============================================================================*/
var ajaxifyShopify = (function(module) {

  'use strict';

  var dom = theme.dom;
  var init;
  var settings, isUpdating, cartInit, drawerHeight, cssTransforms, cssTransforms3d, nojQueryLoad;
  var formContainer, btnClass, wrapperClass, addToCart, flipCart, flipContainer;
  var cartCountSelector, cartCostSelector, toggleCartButtons;
  var cartContainer, drawerCaret, modalContainer, modalOverlay, closeCart, drawerContainer, prependDrawerTo;
  var updateCountPrice, flipSetup, revertFlipButton, modalSetup, showModal, sizeModal, hideModal;
  var drawerSetup, showDrawer, hideDrawer, sizeDrawer, loadCartImages, formOverride;
  var itemAddedCallback, itemErrorCallback, cartUpdateCallback, setToggleButtons, flipCartUpdateCallback;
  var buildCart, cartTemplate, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors;
  var scrollTop, toggleCallback, validateQty, showCartQtyError;
  var toggleClickHandler, escapeKeyHandler, resizeHandler, formSubmitHandler;
  var cartFormSubmitBound = false;

  init = function(options) {
    settings = {
      method: 'drawer',
      formSelector: 'form[action^="/cart/add"]',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      toggleCartButton: null,
      btnClass: null,
      wrapperClass: null,
      useCartTemplate: false,
      moneyFormat: '${{amount}}',
      disableAjaxCart: false,
      enableQtySelectors: true,
      prependDrawerTo: 'body',
      onToggleCallback: null
    };

    Object.assign(settings, options);
    settings.method = settings.method.toLowerCase();
    module.settings = settings;

    formContainer = dom.qs(settings.formSelector);
    btnClass = settings.btnClass;
    wrapperClass = settings.wrapperClass;
    addToCart = formContainer ? formContainer.querySelector(settings.addToCartSelector) : null;
    flipContainer = null;
    cartCountSelector = settings.cartCountSelector || null;
    cartCostSelector = settings.cartCostSelector ? dom.qs(settings.cartCostSelector) : null;
    toggleCartButtons = settings.toggleCartButton ? dom.qsa(settings.toggleCartButton) : [];
    prependDrawerTo = dom.qs(settings.prependDrawerTo);

    cssTransforms = Modernizr.csstransforms;
    cssTransforms3d = Modernizr.csstransforms3d;
    isUpdating = false;
    nojQueryLoad = dom.hasClass(document.documentElement, 'lt-ie9');
    if (nojQueryLoad) settings.useCartTemplate = false;

    if (settings.enableQtySelectors) qtySelectors();

    if (!settings.disableAjaxCart) {
      switch (settings.method) {
        case 'flip': flipSetup(); break;
        case 'modal':
          if (!dom.byId('ajaxifyCart-overlay')) modalSetup();
          break;
        case 'drawer': drawerSetup(); break;
      }

      escapeKeyHandler = function(evt) {
        if (evt.keyCode === 27) {
          switch (settings.method) {
            case 'flip':
            case 'drawer': hideDrawer(); break;
            case 'modal': hideModal(); break;
          }
        }
      };
      document.addEventListener('keyup', escapeKeyHandler);

      if (addToCart) formOverride();
    }

    adjustCart();
  };

  updateCountPrice = function(cart) {
    if (cartCountSelector) {
      dom.qsa(cartCountSelector).forEach(function(el) {
        dom.html(el, cart.item_count);
        dom.removeClass(el, 'hidden-count');
        if (cart.item_count === 0) dom.addClass(el, 'hidden-count');
      });
    }
    if (cartCostSelector) {
      dom.html(cartCostSelector, Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  flipSetup = function() {
    drawerSetup();
    if (!addToCart) return;

    var flipWrapper = document.createElement('div');
    flipWrapper.className = 'flip';
    dom.wrap(addToCart, flipWrapper);
    dom.addClass(addToCart, 'flip-front');

    var checkoutBtn = document.createElement('a');
    checkoutBtn.href = '/cart';
    checkoutBtn.className = 'flip-back';
    checkoutBtn.id = 'flip-checkout';
    checkoutBtn.style.backgroundColor = '#C00';
    checkoutBtn.style.color = '#fff';
    checkoutBtn.textContent = "Checkout";
    if (btnClass) checkoutBtn.classList.add(btnClass);

    var flipLoader = document.createElement('span');
    flipLoader.className = 'ajaxifyCart-loader';

    var flipExtra = document.createElement('div');
    flipExtra.className = 'flip-extra';
    flipExtra.innerHTML = "or" + ' <a href="#" class="flip-cart">' + "View Cart" + ' (<span></span>)</a>';

    dom.insertAfter(checkoutBtn, addToCart);
    dom.insertAfter(flipLoader, checkoutBtn);
    flipContainer = addToCart.parentNode;
    if (!cssTransforms3d) dom.addClass(flipContainer, 'no-transforms');
    dom.insertAfter(flipExtra, flipContainer);
    flipCart = dom.qs('.flip-cart');

    dom.on(flipCart, 'click', function(e) {
      e.preventDefault();
      showDrawer(true);
    });

    dom.qsa('input[type="checkbox"], input[type="radio"], select', formContainer).forEach(function(input) {
      dom.on(input, 'click', revertFlipButton);
    });
  };

  revertFlipButton = function() {
    if (flipContainer) dom.removeClass(flipContainer, 'is-flipped');
  };

  modalSetup = function() {
    var modalFragment = theme.renderTemplate('modalTemplate', {});
    document.body.appendChild(modalFragment);
    theme.dom.append(document.body, '<div id="ajaxifyCart-overlay"></div>');

    modalContainer = dom.byId('ajaxifyModal');
    modalOverlay = dom.byId('ajaxifyCart-overlay');
    cartContainer = dom.byId('ajaxifyCart');

    dom.on(modalOverlay, 'click', hideModal);

    var closeBtn = document.createElement('button');
    closeBtn.className = 'ajaxifyCart--close';
    closeBtn.title = "Close Cart";
    closeBtn.textContent = "Close Cart";
    modalContainer.insertBefore(closeBtn, modalContainer.firstChild);
    closeCart = closeBtn;
    dom.on(closeCart, 'click', hideModal);

    if (!cssTransforms) dom.addClass(modalContainer, 'no-transforms');

    var onOrientationChange = function() {
      if (dom.hasClass(modalContainer, 'is-visible')) sizeModal('resize');
    };
    var onResize = function() {
      if (!nojQueryLoad && dom.hasClass(modalContainer, 'is-visible')) sizeModal('resize');
    };
    window.addEventListener('orientationchange', onOrientationChange);
    window.addEventListener('resize', onResize);

    setToggleButtons();
  };

  showModal = function(toggle) {
    dom.addClass(document.body, 'ajaxify-modal--visible');
    if (!cartInit && toggle) {
      Shopify.getCart(cartUpdateCallback);
    } else {
      sizeModal();
    }
  };

  sizeModal = function(isResizing) {
    if (!isResizing) dom.css(modalContainer, { opacity: 0 });
    dom.css(modalContainer, {
      'margin-left': -(modalContainer.offsetWidth / 2) + 'px',
      opacity: 1
    });
    dom.addClass(modalContainer, 'is-visible');
    scrollTop();
    toggleCallback({ is_visible: true });
  };

  hideModal = function(e) {
    dom.removeClass(document.body, 'ajaxify-modal--visible');
    if (e) e.preventDefault();
    if (modalContainer) {
      dom.removeClass(modalContainer, 'is-visible');
      dom.removeClass(document.body, 'ajaxify-lock');
    }
    toggleCallback({ is_visible: false });
  };

  drawerSetup = function() {
    var drawerFragment = theme.renderTemplate('drawerTemplate', { wrapperClass: wrapperClass });
    prependDrawerTo.insertBefore(drawerFragment, prependDrawerTo.firstChild);

    drawerContainer = dom.byId('ajaxifyDrawer');
    cartContainer = dom.byId('ajaxifyCart');
    drawerCaret = dom.qs('.ajaxifyDrawer-caret > span');

    setToggleButtons();

    var timeout;
    resizeHandler = function() {
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        if (dom.hasClass(drawerContainer, 'is-visible')) {
          positionCaret();
          sizeDrawer();
        }
      }, 500);
    };
    window.addEventListener('resize', resizeHandler);
    positionCaret();

    function positionCaret() {
      if (toggleCartButtons.length) {
        var toggleCartButton = toggleCartButtons[0];
        var togglePos = dom.offset(toggleCartButton);
        var toggleWidth = toggleCartButton.offsetWidth;
        var toggleMiddle = togglePos.left + toggleWidth / 2;
        dom.css(drawerCaret, { left: toggleMiddle + 'px' });
      }
    }
  };

  showDrawer = function(toggle) {
    if (settings.method === 'flip') {
      Shopify.getCart(flipCartUpdateCallback);
    } else if (!cartInit && toggle) {
      Shopify.getCart(cartUpdateCallback);
    } else if (cartInit && toggle) {
      sizeDrawer();
    }
    dom.addClass(drawerContainer, 'is-visible');
    scrollTop();
    toggleCallback({ is_visible: true });
  };

  hideDrawer = function() {
    drawerContainer.removeAttribute('style');
    dom.removeClass(drawerContainer, 'is-visible');
    scrollTop();
    toggleCallback({ is_visible: false });
  };

  sizeDrawer = function(isEmpty) {
    if (isEmpty) {
      dom.css(drawerContainer, { height: '0px' });
    } else {
      drawerHeight = cartContainer.offsetHeight;
      dom.qsa('.cart-row img').forEach(function(img) { img.style.width = 'auto'; });
      dom.css(drawerContainer, { height: drawerHeight + 'px' });
    }
  };

  loadCartImages = function() {
    var cartImages = dom.qsa('img', cartContainer);
    var count = cartImages.length;
    var index = 0;
    if (count === 0) {
      switch (settings.method) {
        case 'modal': sizeModal(); break;
        case 'flip':
        case 'drawer': sizeDrawer(); break;
      }
      return;
    }
    cartImages.forEach(function(img) {
      if (img.complete) {
        index++;
        if (index === count) finishLoading();
      } else {
        dom.on(img, 'load', function() {
          index++;
          if (index === count) finishLoading();
        });
      }
    });
    function finishLoading() {
      switch (settings.method) {
        case 'modal': sizeModal(); break;
        case 'flip':
        case 'drawer': sizeDrawer(); break;
      }
    }
  };

  formOverride = function() {
    if (formContainer && formSubmitHandler) {
      formContainer.removeEventListener('submit', formSubmitHandler);
    }
    formSubmitHandler = function(e) {
      e.preventDefault();
      dom.removeClass(addToCart, 'is-added');
      dom.addClass(addToCart, 'is-adding');
      dom.qsa('.qty-error').forEach(function(el) { dom.remove(el); });
      Shopify.addItemFromForm(e.target, itemAddedCallback, itemErrorCallback);
      if (settings.method === 'flip') dom.addClass(flipContainer, 'flip--is-loading');
    };
    if (formContainer) formContainer.addEventListener('submit', formSubmitHandler);
  };

  itemAddedCallback = function() {
    dom.removeClass(addToCart, 'is-adding');
    dom.addClass(addToCart, 'is-added');
    if (settings.method === 'flip') {
      setTimeout(function() {
        dom.removeClass(flipContainer, 'flip--is-loading');
        dom.addClass(flipContainer, 'is-flipped');
      }, 600);
    }
    Shopify.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function(XMLHttpRequest) {
    if (settings.method === 'flip') dom.removeClass(flipContainer, 'flip--is-loading');
    if (addToCart) dom.removeClass(addToCart, 'is-adding');
    var data;
    try { data = JSON.parse(XMLHttpRequest.responseText); } catch (e) { data = {}; }
    var status = data.status || XMLHttpRequest.status;
    var message = data.description || data.message;
    if (!message && data.errors) {
      message = typeof data.errors === 'string' ? data.errors : Object.values(data.errors).join(' ');
    }
    if (message) {
      showCartQtyError(message);
    }
    if (status == 422) {
      Shopify.getCart(function(cart) { updateCountPrice(cart); });
    }
  };

  showCartQtyError = function(message) {
    dom.qsa('.qty-error').forEach(function(el) { dom.remove(el); });
    var errorEl = document.createElement('div');
    errorEl.className = 'errors qty-error';
    errorEl.textContent = message;
    var target = (formContainer && formContainer.querySelector('button[type="submit"]')) ||
      dom.qs('form[action^="/cart/add"] button[type="submit"]') ||
      formContainer ||
      dom.qs('form[action^="/cart/add"]');
    if (target) dom.insertAfter(errorEl, target);
  };

  cartUpdateCallback = function(cart) {
    updateCountPrice(cart);
    switch (settings.method) {
      case 'flip':
        var flipSpan = dom.qs('.flip-cart span');
        if (flipSpan) dom.html(flipSpan, cart.item_count);
        break;
      case 'modal':
        buildCart(cart);
        if (modalContainer && !dom.hasClass(modalContainer, 'is-visible')) showModal(true);
        break;
      case 'drawer':
        buildCart(cart);
        if (!dom.hasClass(drawerContainer, 'is-visible')) showDrawer();
        else scrollTop();
        break;
    }
  };

  setToggleButtons = function() {
    toggleCartButtons = settings.toggleCartButton ? dom.qsa(settings.toggleCartButton) : [];
    if (!toggleCartButtons.length) return;

    toggleClickHandler = function(e) {
      e.preventDefault();
      switch (settings.method) {
        case 'modal':
          if (dom.hasClass(modalContainer, 'is-visible')) hideModal();
          else showModal(true);
          break;
        case 'drawer':
        case 'flip':
          if (dom.hasClass(drawerContainer, 'is-visible')) hideDrawer();
          else showDrawer(true);
          break;
      }
    };

    toggleCartButtons.forEach(function(button) {
      dom.off(button, 'click', toggleClickHandler);
      dom.on(button, 'click', toggleClickHandler);
    });
  };

  flipCartUpdateCallback = function(cart) {
    buildCart(cart);
  };

  buildCart = function(cart) {
    if (!settings.useCartTemplate || cart.item_count === 0) dom.empty(cartContainer);

    if (cart.item_count === 0) {
      dom.append(cartContainer, '<h2>' + "Your cart is currently empty." + '</h2><span class="cart--continue-message">' + "Continue browsing \u003ca href=\"\/collections\/all\"\u003ehere\u003c\/a\u003e." + '</span><span class="cart--cookie-message">' + "Enable cookies to use the shopping cart" + '</span>');
      switch (settings.method) {
        case 'modal': sizeModal('resize'); break;
        case 'flip':
        case 'drawer':
          sizeDrawer();
          if (!dom.hasClass(drawerContainer, 'is-visible') && cartInit) sizeDrawer(true);
          break;
      }
      return;
    }

    if (settings.useCartTemplate) {
      cartTemplate(cart);
      return;
    }

    cartContainer.appendChild(theme.renderCartTemplate(cart, btnClass));
    adjustCart();

    switch (settings.method) {
      case 'modal': loadCartImages(); break;
      case 'flip':
      case 'drawer':
        if (cart.item_count > 0) loadCartImages();
        else sizeDrawer(true);
        break;
    }
    cartInit = true;
  };

  cartTemplate = function(cart) {
    fetch('/cart', {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      cache: 'no-store'
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Failed to load cart');
        }

        return response.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Try the exact cart form first
        var form = doc.querySelector('form[action="/cart"]');

        // Fallback for themes where action contains additional attributes/query params
        if (!form) {
          form = doc.querySelector('form[action^="/cart"]');
        }

        if (!form) {
          console.warn('Ajaxify cart: cart form not found in /cart response');
          return;
        }

        // Replace current drawer content
        dom.empty(cartContainer);

        // Import the form into the current document
        var importedForm = document.importNode(form, true);

        cartContainer.appendChild(importedForm);

        // Re-bind cart functionality
        adjustCart();

        // Resize drawer after new content is inserted
        if (settings.method === 'modal') {
          loadCartImages();
        } else if (settings.method === 'drawer' || settings.method === 'flip') {
          if (cart.item_count > 0) {
            loadCartImages();
          } else {
            sizeDrawer(true);
          }
        }

        cartInit = true;
      })
      .catch(function(error) {
        console.error('Ajaxify cart update error:', error);
      });
  };

  adjustCart = function() {
    if (settings.useCartTemplate) createQtySelectors();

    if (!cartFormSubmitBound) {
      dom.delegate(document.body, 'submit', 'form.cart-form', function(evt) {
        if (isUpdating) evt.preventDefault();
      });
      cartFormSubmitBound = true;
    }

    dom.qsa('.ajaxifyCart--qty span').forEach(function(el) {
      dom.off(el, 'click', el._ajaxifyQtyClick);
      el._ajaxifyQtyClick = function() {
        if (isUpdating) return;
        var line = el.getAttribute('data-line');
        var qtySelector = el.parentNode.querySelector('.ajaxifyCart--num');
        var qty = parseInt(dom.val(qtySelector), 10);
        qty = validateQty(qty);
        if (dom.hasClass(el, 'ajaxifyCart--add')) qty += 1;
        else qty = qty <= 0 ? 0 : qty - 1;
        if (line) updateQuantity(line, qty);
        else dom.val(qtySelector, qty);
      };
      dom.on(el, 'click', el._ajaxifyQtyClick);
    });

    dom.qsa('.ajaxifyCart--num').forEach(function(el) {
      dom.off(el, 'change', el._ajaxifyQtyChange);
      el._ajaxifyQtyChange = function() {
        if (isUpdating) return;
        var line = el.getAttribute('data-line');
        var qty = el.value;
        if (!(parseFloat(qty) == parseInt(qty, 10)) || isNaN(qty)) {
          dom.val(el, 1);
          return;
        }
        if (line) updateQuantity(line, qty);
      };
      dom.on(el, 'change', el._ajaxifyQtyChange);

      dom.off(el, 'focus', el._ajaxifyQtyFocus);
      el._ajaxifyQtyFocus = function() {
        setTimeout(function() { el.select(); }, 50);
      };
      dom.on(el, 'focus', el._ajaxifyQtyFocus);
    });

    dom.qsa('.ajaxifyCart--remove').forEach(function(el) {
      dom.off(el, 'click', el._ajaxifyRemoveClick);
      el._ajaxifyRemoveClick = function(e) {
        var line = el.getAttribute('data-line');
        if (!line) return;
        e.preventDefault();
        updateQuantity(line, 0);
      };
      dom.on(el, 'click', el._ajaxifyRemoveClick);
    });

    dom.qsa('textarea[name="note"]').forEach(function(noteArea) {
      dom.off(noteArea, 'change', noteArea._ajaxifyNoteChange);
      noteArea._ajaxifyNoteChange = function() {
        Shopify.updateCartNote(noteArea.value, function() {});
      };
      dom.on(noteArea, 'change', noteArea._ajaxifyNoteChange);
    });

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }

    function updateQuantity(line, qty) {
      isUpdating = true;
      var selector = settings.useCartTemplate ? '.cart-row[data-line="' + line + '"]' : '.ajaxifyCart--row[data-line="' + line + '"]';
      var row = dom.qs(selector);
      if (row) dom.addClass(row, 'ajaxifyCart--is-loading');
      if (qty === 0 && row) dom.addClass(row, 'is-removed');
      setTimeout(function() {
        Shopify.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }
  };

  adjustCartCallback = function(cart) {
    updateCountPrice(cart);
    if (cart.item_count === 0) {
      switch (settings.method) {
        case 'modal': break;
        case 'flip':
        case 'drawer': hideDrawer(); break;
      }
    }
    setTimeout(function() {
      isUpdating = false;
      Shopify.getCart(buildCart);
    }, 150);
  };

  createQtySelectors = function() {
    dom.qsa('input[type="number"]', cartContainer).forEach(function(el) {
      var currentQty = parseInt(dom.val(el), 10);
      var fragment = theme.renderTemplate('ajaxifyQty', {
        line: el.getAttribute('data-line'),
        itemQty: currentQty + ' x',
        itemAdd: currentQty + 1,
        itemMinus: currentQty - 1
      });
      dom.insertAfter(fragment, el);
      dom.remove(el);
    });

    dom.qsa('a[href^="/cart/change"]', cartContainer).forEach(function(el) {
      dom.addClass(el, 'ajaxifyCart--remove');
    });
  };

  qtySelectors = function() {
    var qtyMin = 0;

      dom.qsa('input[type="number"]').forEach(function(el) {
      if (el.closest('form[action^="/cart/add"]')) return;
      if (el.closest('.js-qty')) return;
      var currentQty = parseInt(dom.val(el), 10);
      var fragment = theme.renderTemplate('jsQty', {
        key: el.getAttribute('data-id'),
        itemQty: currentQty,
        itemAdd: currentQty + 1,
        itemMinus: currentQty - 1,
        inputName: el.getAttribute('name'),
        inputId: el.getAttribute('id')
      });
      var wrapper = fragment.querySelector ? fragment.querySelector('.js-qty') : null;

    });

    dom.qsa('.js--qty-adjuster').forEach(function(el) {
      if (el.closest('form[action^="/cart/add"]')) return;
      dom.bindJsQtyAdjuster(el, qtyMin);
    });
  };

  scrollTop = function() {
    if ((document.body.scrollTop || document.documentElement.scrollTop) > 0) {
      dom.animateScrollTop(250);
    }
  };

  toggleCallback = function(data) {
    if (typeof settings.onToggleCallback === 'function') {
      settings.onToggleCallback.call(this, data);
    }
  };

  validateQty = function(qty) {
    if ((parseFloat(qty) == parseInt(qty, 10)) && !isNaN(qty)) return qty;
    return 1;
  };

  module = { init: init, settings: settings };
  return module;

}(ajaxifyShopify || {}));




/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  var self = this;
  document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
  document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
  document.addEventListener('shopify:section:select', this._onSelect.bind(this));
  document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
  document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
  document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

Object.assign(theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = theme.dom.qs('[data-section-id]', evt.target);
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter(function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    var instance = this.instances.find(function(item) {
      return item.id === evt.detail.sectionId;
    });

    if (typeof instance !== 'undefined' && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this.instances.find(function(item) {
      return item.id === evt.detail.sectionId;
    });

    if (typeof instance !== 'undefined' && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this.instances.find(function(item) {
      return item.id === evt.detail.sectionId;
    });

    if (typeof instance !== 'undefined' && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this.instances.find(function(item) {
      return item.id === evt.detail.sectionId;
    });

    if (typeof instance !== 'undefined' && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    theme.dom.qsa('[data-section-type=' + type + ']').forEach(function(container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});


/* ================ MODULES ================ */
/* eslint-disable no-new */
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  var dom = theme.dom;
  timber.cache = {
    html: document.documentElement,
    body: document.body,
    breadcrumbs: dom.qs('.breadcrumb'),
    navigation: dom.byId('accessibleNav'),
    hasDropdownItem: dom.qsa('.site-nav--has-dropdown'),
    menuToggle: dom.qs('.menu-toggle'),
    productImageWrap: dom.byId('productPhoto'),
    productImage: dom.byId('productPhotoImg'),
    thumbImages: dom.qsa('#productThumbs a.product-photo-thumb'),
    shareButtons: dom.qsa('.social-sharing'),
    collectionFilters: dom.byId('collectionFilters'),
    advancedFilters: dom.qsa('.advanced-filters'),
    toggleFilterBtn: dom.byId('toggleFilters'),
    emptyCart: dom.byId('EmptyCart'),
    ajaxCartContainer: dom.byId('ajaxifyCart'),
    cartNoCookies: 'cart--no-cookies',
    featuredBoxImages: dom.qsa('.featured-box--inner'),
    featuredBoxTitles: dom.qsa('.featured-box--title')
  };
};

timber.cacheVariables = function () {
  timber.vars = {
    bpLarge: 769,
    mediaQueryLarge: 'screen and (min-width: 769px)',
    isLargeBp: false,
    isTouch: theme.dom.hasClass(timber.cache.html, 'supports-touch')
  };
};

timber.init = function () {
  timber.cacheSelectors();
  timber.cacheVariables();

  theme.dom.removeClass(timber.cache.html, 'no-js');
  theme.dom.addClass(timber.cache.html, 'js');
  if ('ontouchstart' in window) {
    theme.dom.removeClass(timber.cache.html, 'no-touch');
    theme.dom.addClass(timber.cache.html, 'touch');
  }

  timber.initCart();
  timber.responsiveVideos();
  timber.toggleFilters();

  
};

timber.accessibleNav = function () {
  var nav = timber.cache.navigation;
  if (!nav) return;
  var dom = theme.dom;
  var allLinks = dom.qsa('a', nav);
  var topLevel = dom.qsa(':scope > li > a', nav);
  var parents = dom.qsa('.site-nav--has-dropdown', nav);
  var subMenuLinks = dom.qsa('.site-nav--dropdown a', nav);
  var activeClass = 'nav-hover';
  var focusClass = 'nav-focus';
  var touchHandler;

  parents.forEach(function(el) {
    dom.on(el, 'mouseenter', function(evt) {
      if (!dom.hasClass(el, activeClass)) evt.preventDefault();
      showDropdown(el);
    });
    dom.on(el, 'mouseleave', function() { hideDropdown(el); });
  });

  subMenuLinks.forEach(function(el) {
    dom.on(el, 'click', function(evt) { evt.stopImmediatePropagation(); });
  });

  allLinks.forEach(function(el) {
    dom.on(el, 'focus', function() { handleFocus(el); });
    dom.on(el, 'blur', function() { removeFocus(topLevel); });
  });

  function handleFocus(el) {
    var isSubItem = !!el.closest('.site-nav--dropdown');
    if (!isSubItem) {
      removeFocus(topLevel);
      addFocus(el);
    } else {
      addFocus(el.closest('.site-nav--has-dropdown').querySelector('a'));
    }
  }

  function showDropdown(el) {
    dom.addClass(el, activeClass);
    setTimeout(function() {
      touchHandler = function() { hideDropdown(el); };
      dom.on(timber.cache.body, 'touchstart', touchHandler);
    }, 250);
  }

  function hideDropdown(el) {
    dom.removeClass(el, activeClass);
    if (touchHandler) dom.off(timber.cache.body, 'touchstart', touchHandler);
  }

  function addFocus(el) { dom.addClass(el, focusClass); }
  function removeFocus(els) { els.forEach(function(el) { dom.removeClass(el, focusClass); }); }
};

timber.responsiveNav = function () {
  var dom = theme.dom;
  window.addEventListener('resize', function() {
    afterResize(function() {
      var moreList = dom.byId('moreMenu--list');
      if (moreList && timber.cache.navigation) {
        timber.cache.navigation.insertAdjacentHTML('beforeend', moreList.innerHTML);
      }
      var moreMenu = dom.byId('moreMenu');
      if (moreMenu) moreMenu.remove();
      timber.alignMenu();
      timber.accessibleNav();
    }, 200, 'uniqueID');
  });
  timber.alignMenu();
  timber.accessibleNav();
};

timber.alignMenu = function () {
  var dom = theme.dom;
  var nav = timber.cache.navigation;
  if (!nav || window.innerWidth < timber.vars.bpLarge) return;

  var wrapperWidth = nav.offsetWidth - 101;
  var menuhtml = '';
  var w = 0;
  var i = 0;
  var children = Array.prototype.slice.call(nav.children);

  children.forEach(function(el) {
    if (!dom.hasClass(el, 'large-hide')) w += dom.outerWidth(el, true);
    if (wrapperWidth < w) {
      menuhtml += el.outerHTML;
      el.remove();
      if (!dom.hasClass(el, 'large-hide')) i++;
    }
  });

  if (wrapperWidth < w) {
    nav.insertAdjacentHTML('beforeend',
      '<li id="moreMenu" class="site-nav--has-dropdown">' +
        '<a href="#">' + theme.strings.navigation.more_link + '<span class="icon icon-arrow-down" aria-hidden="true"></span></a>' +
        '<ul id="moreMenu--list" class="site-nav--dropdown">' + menuhtml + '</ul></li>'
    );
    if (i <= 1) {
      var moreList = dom.byId('moreMenu--list');
      if (moreList) nav.insertAdjacentHTML('beforeend', moreList.innerHTML);
      var moreMenu = dom.byId('moreMenu');
      if (moreMenu) moreMenu.remove();
    }
  }
};

timber.toggleMenu = function () {
  var dom = theme.dom;
  var showDropdownClass = 'show-dropdown';
  var showNavClass = 'show-nav';

  if (timber.cache.menuToggle) {
    dom.on(timber.cache.menuToggle, 'click', function() {
      dom.toggleClass(timber.cache.html, showNavClass);
      var modal = dom.byId('ajaxifyModal');
      if (modal && dom.hasClass(modal, 'is-visible')) {
        dom.removeClass(modal, 'is-visible');
        dom.addClass(timber.cache.html, showNavClass);
      }
    });
  }

  timber.cache.hasDropdownItem.forEach(function(el) {
    dom.on(el, 'click', function(evt) {
      if ((!dom.hasClass(el, showDropdownClass) && timber.vars.isTouch) ||
          (!dom.hasClass(el, showDropdownClass) && dom.hasClass(timber.cache.html, showNavClass))) {
        evt.preventDefault();
        dom.addClass(el, showDropdownClass);
        document.addEventListener('click', handleClickOutsideDropdown);
      }
      function handleClickOutsideDropdown(evt) {
        if (evt.target !== el && !el.contains(evt.target)) {
          dom.removeClass(el, showDropdownClass);
          document.removeEventListener('click', handleClickOutsideDropdown);
        }
      }
    });
  });
};

timber.initCart = function() {
  if (theme.settings.cartType != 'page'){
    ajaxifyShopify.init({
      method: theme.settings.cartType,
      wrapperClass: 'wrapper',
      formSelector: '#addToCartForm',
      addToCartSelector: '#addToCart',
      cartCountSelector: '.cart-count',
      toggleCartButton: '.cart-toggle',
      useCartTemplate: true,
      btnClass: 'btn',
      moneyFormat: moneyFormat,
      disableAjaxCart: false,
      enableQtySelectors: true
    });
  }

  if (!timber.cookiesEnabled()) {
    if (timber.cache.emptyCart) theme.dom.addClass(timber.cache.emptyCart, timber.cache.cartNoCookies);
    if (timber.cache.ajaxCartContainer) theme.dom.addClass(timber.cache.ajaxCartContainer, timber.cache.cartNoCookies);
  }
};

timber.cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;
  if (!cookieEnabled){
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
  }
  return cookieEnabled;
};

timber.equalHeights = function () {
  window.addEventListener('load', function() { timber.resizeElements(this); });
  window.addEventListener('resize', function() {
    afterResize(function() { timber.resizeElements(this); }, 250, 'id');
  });
  timber.resizeElements(this);
};

timber.resizeElements = function(container, id) {
  if (!container) return;
  var dom = theme.dom;
  if (id) container.setAttribute('data-section-id', id);
  var gridImages = dom.qsa('.product-grid-image', container);
  gridImages.forEach(function(el) { el.style.height = 'auto'; });
  equalHeights(gridImages);

  var featuredBoxImages = dom.qsa('.featured-box--inner', container);
  var featuredBoxTitles = dom.qsa('.featured-box--title', container);
  featuredBoxImages.forEach(function(el) { el.style.height = 'auto'; });
  featuredBoxTitles.forEach(function(el) { el.style.height = 'auto'; });
  equalHeights(featuredBoxImages);
  equalHeights(featuredBoxTitles);
};

timber.responsiveVideos = function () {
  var dom = theme.dom;
  dom.qsa('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]').forEach(function(iframe) {
    if (!iframe.parentElement || !iframe.parentElement.classList.contains('video-wrapper')) {
      var wrapper = document.createElement('div');
      wrapper.className = 'video-wrapper';
      dom.wrap(iframe, wrapper);
    }
  });
  dom.qsa('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"], iframe#admin_bar_iframe').forEach(function(iframe) {
    iframe.src = iframe.src;
  });
};

timber.toggleFilters = function () {
  var dom = theme.dom;
  if (timber.cache.collectionFilters && timber.cache.toggleFilterBtn) {
    dom.on(timber.cache.toggleFilterBtn, 'click', function() {
      dom.toggleClass(timber.cache.toggleFilterBtn, 'is-active');
      dom.slideToggle(timber.cache.collectionFilters, 200);
      if (timber.cache.breadcrumbs && window.pageYOffset > dom.offset(timber.cache.breadcrumbs).top) {
        window.scrollTo(0, dom.offset(timber.cache.breadcrumbs).top);
      }
    });
  }
};

timber.sortFilters = function () {
  var dom = theme.dom;
  timber.cache.advancedFilters.forEach(function(el) {
    var tags = Array.prototype.slice.call(el.querySelectorAll('li'));
    var aNumber = /\d+/;
    var sorted = false;
    tags.sort(function(a, b) {
      var aNum = parseInt(aNumber.exec(a.textContent), 10);
      var bNum = parseInt(aNumber.exec(b.textContent), 10);
      if (isNaN(aNum) || isNaN(bNum)) return 0;
      sorted = true;
      return aNum - bNum;
    });
    if (sorted) tags.forEach(function(tag) { el.appendChild(tag); });
  });
};

timber.formatMoney = function (val) {

  

  
    if (moneyFormat.indexOf('money') === -1) {
      if ( (moneyFormat.indexOf('{{amount}}') > -1) && (moneyFormat.indexOf('.') === -1) ) {
        val = val.replace('.','<sup>') + '</sup>';
      }
      else if ( (moneyFormat.indexOf('{{ amount }}') > -1) && (moneyFormat.indexOf('.') === -1) ) {
        val = val.replace('.','<sup>') + '</sup>';
      }
      else if (moneyFormat.indexOf('{{ amount_with_comma_separator }}') > -1) {
        val = val.replace(',','<sup>') + '</sup>';
      }
      else if (moneyFormat.indexOf('{{amount_with_comma_separator}}') > -1) {
        val = val.replace(',','<sup>') + '</sup>';
      }
    }
  

  return val;
};

timber.formatSaleTag = function (val) {
  if (moneyFormat.indexOf('money') === -1) {
    if ( (moneyFormat.indexOf('{{amount}}') > -1) && (moneyFormat.indexOf('.') === -1) ) {
      if ( (val.indexOf('.00') > -1) || parseInt(val.replace(/[^0-9]/g, ''), 10) > 1000 ) {
        return val.split('.')[0];
      }
    }
    else if (moneyFormat.indexOf('{{amount_with_comma_separator}}') > -1) {
      if ( (val.indexOf(',00') > -1) || parseInt(val.replace(/[^0-9]/g, ''), 10) > 1000 ) {
        return val.split(',')[0];
      }
    }
  }
  return val;
};

document.addEventListener('DOMContentLoaded', timber.init);

/*!
 * imagesLoaded PACKAGED v4.1.1
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

!function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},n=i[t]=i[t]||{};return n[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=0,o=i[n];e=e||[];for(var r=this._onceEvents&&this._onceEvents[t];o;){var s=r&&r[o];s&&(this.off(t,o),delete r[o]),o.apply(this,e),n+=s?0:1,o=i[n]}return this}},t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.imagesLoaded=e(t,t.EvEmitter)}(window,function(t,e){function i(t,e){for(var i in e)t[i]=e[i];return t}function n(t){var e=[];if(Array.isArray(t))e=t;else if("number"==typeof t.length)for(var i=0;i<t.length;i++)e.push(t[i]);else e.push(t);return e}function o(t,e,r){return this instanceof o?("string"==typeof t&&(t=document.querySelectorAll(t)),this.elements=n(t),this.options=i({},this.options),"function"==typeof e?r=e:i(this.options,e),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(function(){this.check()}.bind(this))):new o(t,e,r)}function r(t){this.img=t}function s(t,e){this.url=t,this.element=e,this.img=new Image}var h=t.jQuery,a=t.console;o.prototype=Object.create(e.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),this.options.background===!0&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&d[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=t.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var d={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,t),n=i.exec(e.backgroundImage)}},o.prototype.addImage=function(t){var e=new r(t);this.images.push(e)},o.prototype.addBackground=function(t,e){var i=new s(t,e);this.images.push(i)},o.prototype.check=function(){function t(t,i,n){setTimeout(function(){e.progress(t,i,n)})}var e=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(e){e.once("progress",t),e.check()}):void this.complete()},o.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,t,e)},o.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},r.prototype=Object.create(e.prototype),r.prototype.check=function(){var t=this.getIsImageComplete();return t?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&void 0!==this.img.naturalWidth},r.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},r.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var t=this.getIsImageComplete();t&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},o.makeJQueryPlugin=function(e){e=e||t.jQuery,e&&(h=e,h.fn.imagesLoaded=function(t,e){var i=new o(this,t,e);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});


/* ================ SECTIONS ================ */
window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    timber.cacheSelectors();
    timber.toggleMenu();

    window.addEventListener('load', timber.responsiveNav);
    window.dispatchEvent(new Event('resize'));
  }

  return Header;
})();

theme.Slideshow = function(el) {
  var $ = timber.$;
  this.cache = {
    $slider: $(el),
    sliderArgs: {
      animation: 'slide',
      animationSpeed: 500,
      pauseOnHover: true,
      keyboard: false,
      slideshow: $(el).data('slider-home-auto'),
      slideshowSpeed: $(el).data('slider-home-rate'),
      smoothHeight: true,
      before: function(slider) {
        $(slider).resize();
        $(slider)
          .find('.slide')
          .not('.flex-active-slide')
          .removeClass('slide-hide');
      },
      after: function(slider) {
        $(slider)
          .find('.slide')
          .not('.flex-active-slide')
          .addClass('slide-hide');
        $(slider).resize();
      },
      start: function(slider) {
        $(slider)
          .find('.slide')
          .not('.flex-active-slide')
          .addClass('slide-hide');
        if (
          $(slider)
            .find('.slide')
            .not('.clone').length === 1
        ) {
          $(slider)
            .find('.flex-direction-nav')
            .remove();
        }
        $(window).trigger('resize');
        slider.addClass('loaded');
        if ($('#slider').data('loaded-index') !== undefined) {
          $('#slider').flexslider($('#slider').data('loaded-index'));
        }
      }
    }
  };
  if (this.cache.$slider.find('li').length === 1) {
    this.cache.sliderArgs.touch = false;
  }
  this.cache.$slider.flexslider(this.cache.sliderArgs);
};

theme.slideshows = theme.slideshows || {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    this.container = container;
    var id = container.getAttribute('data-section-id');
    this.slideshow = '#heroSlider--' + id;
    var numberOfSlides = theme.dom.qsa(this.slideshow + ' li').length;

    if (numberOfSlides <= 0) return;

    theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = Object.assign(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $ = timber.$;
      var $slideshow = $(this.slideshow);
      var $slide = $('#slide--' + evt.detail.blockId + ':not(.clone)');

      var slideIndex = $slide.data('flexslider-index');
      var $slideImg = $slide.find('img') || $slide.find('svg');

      $slide.imagesLoaded($slideImg, function() {
        $slideshow.flexslider(slideIndex);
        $slideshow.resize();
        $slideshow.flexslider('pause');
      });
    },

    onBlockDeselect: function() {
      timber.$(this.slideshow).flexslider('play');
    }
  }
);

window.theme = window.theme || {};

theme.FeaturedCollections = (function() {
  function FeaturedCollections(container) {
    this.container = container;
    timber.cacheSelectors();
    timber.resizeElements(container);

    window.addEventListener('resize', function() {
      timber.resizeElements(container);
    });
  }

  return FeaturedCollections;
})();

theme.FeaturedCollections.prototype = Object.assign(
  {},
  theme.FeaturedCollections.prototype,
  {
    onLoad: function() {
      timber.resizeElements(this.container);
    }
  }
);

window.theme = window.theme || {};

theme.ListCollections = (function() {
  function ListCollections(container) {
    this.container = container;
    timber.cacheSelectors();
    timber.resizeElements(container);

    window.addEventListener('resize', function() {
      timber.resizeElements(container);
    });
  }

  return ListCollections;
})();

theme.ListCollections.prototype = Object.assign(
  {},
  theme.ListCollections.prototype,
  {
    onLoad: function() {
      var self = this;
      window.addEventListener('resize', function() {
        timber.resizeElements(self.container);
      });
    }
  }
);

/* eslint-disable no-new */
theme.Product = (function() {
  var dom = theme.dom;
  var defaults = {
    selectors: {
      addToCart: '#addToCart',
      productPrice: '#productPrice',
      comparePrice: '#comparePrice',
      addToCartText: '#addToCartText',
      quantityElements: '.quantity-selector, label + .js-qty',
      optionSelector: 'productSelect'
    }
  };

  function Product(container) {
    this.container = container;
    var sectionId = this.sectionId = container.getAttribute('data-section-id');

    this.settings = Object.assign({}, defaults, {
      sectionId: sectionId,
      enableHistoryState: true,
      showComparePrice: container.getAttribute('data-show-compare-at-price'),
      ajaxCartMethod: container.getAttribute('data-ajax-cart-method'),
      stockSetting: container.getAttribute('data-stock'),
      incomingMessage: container.getAttribute('data-incoming-transfer'),
      selectors: {
        originalSelectorId: 'productSelect-' + sectionId,
        addToCart: dom.byId('addToCart-' + sectionId),
        SKU: dom.qs('.variant-sku', container),
        productPrice: dom.byId('productPrice-' + sectionId),
        comparePrice: dom.byId('comparePrice-' + sectionId),
        addToCartText: dom.byId('addToCartText-' + sectionId),
        quantityElements: dom.qs('.quantity-selector-' + sectionId, container) || dom.qs('input[name="quantity"]', container),
        variantQuantity: dom.byId('variantQuantity-' + sectionId),
        variantIncoming: dom.byId('variantIncoming-' + sectionId),
        productImageContainer: dom.byId('productPhotoContainer-' + sectionId),
        productImageWrapper: dom.qsa('[id^="productPhotoWrapper-' + sectionId + '"]'),
        productImage: dom.qsa('[id^="productPhotoImg-' + sectionId + '"]'),
        productFullDetails: dom.qs('.full-details', container),
        thumbImages: dom.qsa('#productThumbs-' + sectionId + ' a.product-photo-thumb')
      }
    });

    if (dom.hasClass(document.body, 'template-index')) {
      this.settings.enableHistoryState = false;
    }

    var productJsonEl = dom.byId('ProductJson-' + sectionId);
    if (!productJsonEl || !productJsonEl.innerHTML) {
      return;
    }

    this.zoomEnabled = container.getAttribute('data-zoom-enabled');
    this.productSingleObject = JSON.parse(productJsonEl.innerHTML);
    this.addVariantInfo();
    this.init();
    Shopify.Image.preload(this.productSingleObject.images);

    if (this.settings.ajaxCartMethod != 'page') {
      ajaxifyShopify.init({
        method: 'modal',
        wrapperClass: 'wrapper',
        formSelector: '#addToCartForm-' + sectionId,
        addToCartSelector: '#addToCart-' + sectionId,
        cartCountSelector: '.cart-count',
        toggleCartButton: '.cart-toggle',
        useCartTemplate: true,
        btnClass: 'btn',
        moneyFormat: moneyFormat,
        disableAjaxCart: false,
        enableQtySelectors: false
      });
    }
  }

  Product.prototype = Object.assign({}, Product.prototype, {
    init: function() {
      this.initProductVariant();
      this.addQuantityButtons();
      this.productImageSwitch();
      this.initBreakpoints();
      if (timber.vars.isLargeBp && this.zoomEnabled) productImageZoom();
    },

    onUnload: function() {},

    addVariantInfo: function() {
      if (!this.productSingleObject) return;
      if (this.settings.stockSetting === 'false' && this.settings.incomingMessage === 'false') return;
      var variantJsonEl = dom.byId('VariantJson-' + this.settings.sectionId);
      if (!variantJsonEl) return;
      var variantInfo = JSON.parse(variantJsonEl.innerHTML);
      for (var i = 0; i < variantInfo.length; i++) {
        Object.assign(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    addQuantityButtons: function() {
      var qtyLabel = dom.qs('.quantity-selector-' + this.settings.sectionId, this.container);
      if (qtyLabel) dom.show(qtyLabel);
      
      this.qtySelectors();
      
      var qtyWrapper = dom.qs('.js-qty', this.container);
      if (qtyWrapper) {
        dom.show(qtyWrapper);
        this.settings.selectors.quantityElements = qtyWrapper;
      }
    },

    qtySelectors: function() {
      var productForm = dom.qs('form[action^="/cart/add"]', this.container);
      if (!productForm) return;
      var qtyMin = 1;

      dom.qsa('input[type="number"]', productForm).forEach(function(el) {
        if (el.closest('.js-qty')) return;
        var currentQty = parseInt(dom.val(el), 10);
        var fragment = theme.renderTemplate('jsQty', {
          key: el.getAttribute('data-id'),
          itemQty: currentQty,
          itemAdd: currentQty + 1,
          itemMinus: currentQty - 1,
          inputName: el.getAttribute('name'),
          inputId: el.getAttribute('id')
        });
        var wrapper = fragment.querySelector ? fragment.querySelector('.js-qty') : null;
        if (wrapper) {
          dom.insertAfter(wrapper, el);
        } else {
          dom.insertAfter(fragment, el);
        }
        dom.remove(el);
      });

      dom.qsa('.js--qty-adjuster', productForm).forEach(function(el) {
        dom.bindJsQtyAdjuster(el, qtyMin);
      });
    },

    initBreakpoints: function() {
      var self = this;
      self.zoomType = self.container.getAttribute('data-zoom-enabled');
      if (!dom.hasClass(document.documentElement, 'lt-ie9')) {
        enquire.register(timber.vars.mediaQueryLarge, {
          match: function() {
            if (self.zoomType) productImageZoom();
            timber.vars.isLargeBp = true;
          },
          unmatch: function() {
            if (self.zoomType && self.settings.selectors.productImage.length) {
              self.settings.selectors.productImage.forEach(function(img) {
                var clone = img.cloneNode(true);
                img.parentNode.replaceChild(clone, img);
              });
              if (self.settings.selectors.productImageContainer) {
                timber.$(self.settings.selectors.productImageContainer).trigger('zoom.destroy');
              }
            }
            timber.vars.isLargeBp = false;
          }
        });
      }
    },

    productImageSwitch: function() {
      var self = this;
      if (!this.settings.selectors.thumbImages.length) return;
      this.settings.selectors.thumbImages.forEach(function(thumb) {
        dom.on(thumb, 'click', function(evt) {
          evt.preventDefault();
          self.switchImage(thumb.getAttribute('data-image-id'));
        });
      });
    },

    switchImage: function(imageId) {
      var s = this.settings.selectors;
      s.productImageWrapper.forEach(function(wrapper) {
        if (wrapper.getAttribute('data-image-id') === String(imageId)) dom.removeClass(wrapper, 'hide');
        else dom.addClass(wrapper, 'hide');
      });
      var active = s.productImageWrapper.find(function(w) { return w.getAttribute('data-image-id') === String(imageId); });
      if (active) {
        var img = active.querySelector('img');
        if (img && img.getAttribute('data-zoom') && timber.vars.isLargeBp) productImageZoom();
      }
    },

    initProductVariant: function() {
      if (!this.productSingleObject) return;
      var self = this;
      this.optionSelector = new Shopify.OptionSelectors(self.settings.selectors.originalSelectorId, {
        selectorClass: self.settings.selectors.optionSelector,
        product: self.productSingleObject,
        onVariantSelected: self.productVariantCallback.bind(self),
        enableHistoryState: self.settings.enableHistoryState,
        settings: self.settings
      });
      this.simplifyVariantLabels(this.productSingleObject);
    },

    simplifyVariantLabels: function(productObject) {
      if (productObject.variants.length && productObject.variants[0].title.indexOf('Default') >= 0) {
        dom.qsa('.selector-wrapper', this.container).forEach(function(el) { dom.hide(el); });
      }
    },

    productVariantCallback: function(variant) {
      var s = this.settings.selectors;
      if (variant) {
        if (variant.featured_image) {
          s.productImageWrapper.forEach(function(wrapper) {
            if (wrapper.getAttribute('data-image-id') === String(variant.featured_image.id)) dom.removeClass(wrapper, 'hide');
            else dom.addClass(wrapper, 'hide');
          });
        }
        if (variant.available) {
          dom.removeClass(s.addToCart, 'disabled');
          dom.prop(s.addToCart, 'disabled', false);
          dom.html(s.addToCartText, "Add to Cart");
          dom.removeClass(s.variantQuantity, 'is-visible');
          dom.removeClass(s.variantIncoming, 'is-visible');
          if (s.productFullDetails) {
            dom.attr(s.productFullDetails, 'href', updateUrlParameter(s.productFullDetails.getAttribute('href'), 'variant', variant.id));
          }
          if (variant.inventory_management && variant.inventory_quantity < 10 && variant.inventory_quantity > 0 && this.settings.stockSetting == 'true') {
            dom.html(s.variantQuantity, theme.strings.product.only_left.replace('1', variant.inventory_quantity));
            dom.addClass(s.variantQuantity, 'is-visible');
          }
          if (variant.inventory_quantity <= 0 && variant.incoming != null && variant.next_incoming_date != null) {
            dom.html(s.variantIncoming, theme.strings.product.will_be_in_stock_after.replace('[date]', variant.next_incoming_date));
            dom.addClass(s.variantIncoming, 'is-visible');
          }
        } else {
          dom.addClass(s.addToCart, 'disabled');
          dom.prop(s.addToCart, 'disabled', true);
          dom.html(s.addToCartText, "Sold Out");
          dom.removeClass(s.variantQuantity, 'is-visible');
          dom.removeClass(s.variantIncoming, 'is-visible');
          if (variant.inventory_management && variant.incoming && this.settings.incomingMessage == 'true' && variant.next_incoming_date != null) {
            dom.html(s.variantIncoming, theme.strings.product.will_be_in_stock_after.replace('[date]', variant.next_incoming_date));
            dom.addClass(s.variantIncoming, 'is-visible');
          }
          //dom.hide(s.quantityElements);
        }
        var customPrice = timber.formatMoney(Shopify.formatMoney(variant.price, moneyFormat));
        var a11yPrice = Shopify.formatMoney(variant.price, moneyFormat);
        var customPriceFormat = ' <span aria-hidden="true">' + customPrice + '</span>';
        customPriceFormat += ' <span class="visually-hidden">' + a11yPrice + '</span>';
        if (s.SKU) dom.html(s.SKU, variant.sku);
        if (this.settings.showComparePrice == 'true' && variant.compare_at_price > variant.price) {
          var comparePrice = timber.formatMoney(Shopify.formatMoney(variant.compare_at_price, moneyFormat));
          var a11yComparePrice = Shopify.formatMoney(variant.compare_at_price, moneyFormat);
          customPriceFormat = ' <span aria-hidden="true">' + customPrice + '</span>';
          customPriceFormat += ' <span aria-hidden="true"><s>' + comparePrice + '</s></span>';
          customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Regular price</span> ' + a11yComparePrice + '</span>';
          customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Sale price</span> ' + a11yPrice + '</span>';
        }
        dom.html(s.productPrice, customPriceFormat);
        if (variant.compare_at_price > variant.price) {
          var priceSaving = timber.formatSaleTag(Shopify.formatMoney(variant.compare_at_price - variant.price, moneyFormat));
          dom.html(s.comparePrice, "Save [$]".replace('[$]', priceSaving));
          dom.show(s.comparePrice);
        } else {
          dom.hide(s.comparePrice);
        }
      } else {
        dom.addClass(s.addToCart, 'disabled');
        dom.prop(s.addToCart, 'disabled', true);
        dom.html(s.addToCartText, theme.strings.product.unavailable);
        dom.removeClass(s.variantQuantity, 'is-visible');
        //dom.hide(s.quantityElements);
      }
    }
  });

  function updateUrlParameter(url, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    if (url.match(re)) return url.replace(re, '$1' + key + '=' + value + '$2');
    return url + separator + key + '=' + value;
  }

  function productImageZoom() {
    var $ = timber.$;
    var $productImageWrapper = $('.product__image-wrapper');
    if (timber.vars.isLargeBp) {
      if (!$productImageWrapper.length || dom.hasClass(timber.cache.html, 'supports-touch')) return;
      $productImageWrapper.trigger('zoom.destroy');
      $productImageWrapper.each(function() {
        if ($(this).find('img').attr('data-zoom')) {
          $(this).addClass('image-zoom').zoom({ url: $(this).find('img').attr('data-zoom') });
        }
      });
    }
  }

  return Product;
})();

theme.Maps = (function() {
  var dom = theme.dom;
  var config = { zoom: 14 };
  var apiStatus = null;
  var mapsToLoad = [];

  function Map(container) {
    theme.currentMapContainer = this.container = container;
    var key = container.getAttribute('data-api-key');

    if (typeof key !== 'string' || key === '') return;

    if (apiStatus === 'loaded') {
      var scriptExists = dom.qs('script[src*="' + key + '&"]');
      if (!scriptExists) {
        dom.loadScript('https://maps.googleapis.com/maps/api/js?key=' + key).then(function() {
          apiStatus = 'loaded';
          this.createMap();
        }.bind(this));
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);
      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          dom.loadScript('https://maps.googleapis.com/maps/api/js?key=' + key).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    mapsToLoad.forEach(function(instance) { instance.createMap(); });
  }

  function geolocate(mapEl) {
    return new Promise(function(resolve, reject) {
      var geocoder = new google.maps.Geocoder();
      var address = mapEl.getAttribute('data-address-setting');
      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) reject(status);
        else resolve(results);
      });
    });
  }

  Map.prototype = Object.assign({}, Map.prototype, {
    createMap: function() {
      var mapEl = dom.qs('.map-section__container', this.container);
      var self = this;
      return geolocate(mapEl).then(function(results) {
        var mapOptions = {
          zoom: config.zoom,
          styles: config.styles,
          center: results[0].geometry.location,
          draggable: false,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true
        };
        var map = self.map = new google.maps.Map(mapEl, mapOptions);
        var center = self.center = map.getCenter();
        new google.maps.Marker({ map: map, position: center });
        google.maps.event.addDomListener(window, 'resize', function() {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(center);
        });
      }).catch(function(status) {
        var errorMessage;
        switch (status) {
          case 'ZERO_RESULTS': errorMessage = theme.strings.map.addressNoResults; break;
          case 'OVER_QUERY_LIMIT': errorMessage = theme.strings.map.addressQueryLimit; break;
          default: errorMessage = theme.strings.map.addressError; break;
        }
        if (Shopify.designMode) {
          var mapContainer = mapEl.closest('.map-section');
          if (mapContainer) {
            mapContainer.classList.add('page-width', 'map-section--load-error');
            var contentWrapper = dom.qs('.map-section__content-wrapper', mapContainer);
            if (contentWrapper) contentWrapper.remove();
            var wrapper = dom.qs('.map-section__wrapper', mapContainer);
            if (wrapper) wrapper.innerHTML = '<div class="errors text-center" style="width: 100%;">' + errorMessage + '</div>';
          }
        }
      });
    },

    onUnload: function() {
      if (typeof window.google !== 'undefined' && this.map) {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();

function gm_authFailure() {
  if (!Shopify.designMode) return;
  var container = theme.currentMapContainer;
  if (!container) return;
  container.classList.add('page-width', 'map-section--load-error');
  var contentWrapper = theme.dom.qs('.map-section__content-wrapper', container);
  if (contentWrapper) contentWrapper.remove();
  var wrapper = theme.dom.qs('.map-section__wrapper', container);
  if (wrapper) wrapper.innerHTML = '<div class="errors text-center" style="width: 100%;">' + theme.strings.map.authError + '</div>';
}


document.addEventListener('DOMContentLoaded', function() {
  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('map-section', theme.Maps);
  sections.register('collections-list-template', theme.FeaturedCollections);
  sections.register('list-collections-template', theme.ListCollections);
  sections.register('collection-row-section', theme.CollectionRows);
  sections.register('product-template', theme.Product);
});
